import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { loginUser, clearAuthError, selectAuthLoading, selectAuthError } from '../../../store/slices/authSlice';
import styles from './Login.module.css';
import logo from '../../../assets/images/logoConcesionario.png';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  // Redux state
  const isLoading = useAppSelector(selectAuthLoading);
  const authError = useAppSelector(selectAuthError);

  // Local state
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  // Mostrar mensaje de registro exitoso si viene del registro
  useEffect(() => {
    const message = (location.state as any)?.message;
    if (message) {
      toast.success(message);
      // Limpiar el state para que no se muestre de nuevo
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  // Limpiar errores de Redux cuando el componente se monta
  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Dispatch login action
    const result = await dispatch(loginUser({
      email: formData.email,
      password: formData.password
    }));

    // Si fue exitoso, Redux actualiza isAuthenticated y la navegación es automática
    if (loginUser.fulfilled.match(result)) {
      const username = result.payload.user.username;
      toast.success(`¡Bienvenido, ${username}!`);
      navigate('/dashboard');
    } else {
      toast.error('Error al iniciar sesión');
    }
    // Los errores ya están en Redux state y se muestran en el UI
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.loginHeader}>
          <img src={logo} alt="El 4+2 Motos" className={styles.logo} />
          <h2>Iniciar Sesión</h2>
          <p>Bienvenido al sistema de control de stock</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.loginForm}>
          {authError && (
            <div className={styles.errorMessage}>
              {authError}
            </div>
          )}

          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="tu@email.com"
              required
              autoComplete="email"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className={styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? 'Ingresando...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className={styles.loginFooter}>
          <p>
            ¿No tienes una cuenta?{' '}
            <Link to="/register" className={styles.link}>
              Regístrate aquí
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
